import React from "react";

const Speaker = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M21.126 9.308A3.122 3.122 0 0 1 18 12.418a3.122 3.122 0 0 1-3.126-3.11A3.122 3.122 0 0 1 18 6.197a3.122 3.122 0 0 1 3.126 3.111Zm11.292 23.724c-.514.624-1.317.968-2.26.968H5.842c-.943 0-1.746-.344-2.26-.968-.515-.626-.697-1.476-.511-2.397l4.97-24.74C8.466 3.784 10.417 2 12.303 2h10.883c2.163 0 4.348 1.784 4.773 3.895l4.97 24.74c.186.92.003 1.771-.51 2.396ZM12.163 9.308c0 3.203 2.618 5.81 5.837 5.81s5.837-2.607 5.837-5.81c0-3.204-2.618-5.81-5.837-5.81s-5.837 2.606-5.837 5.81Zm13.696 15.37c0-4.313-3.526-7.823-7.859-7.823s-7.86 3.51-7.86 7.823c0 4.315 3.527 7.824 7.86 7.824s7.86-3.51 7.86-7.824ZM18 19.554c-2.839 0-5.148 2.298-5.148 5.124 0 2.826 2.309 5.125 5.148 5.125 2.839 0 5.148-2.299 5.148-5.125S20.84 19.554 18 19.554Z"
            fill={fill}
        />
    </svg>
);

export default Speaker;